export { default, links, meta } from "./routes/search/main/$articleId.$articleName.tsx";